import React from 'react';
import { Grid, Paper } from '@mui/material';
import QueryDisease from './QueryDisease';
import QueryPhenotype from './QueryPhenotype';
import QueryGene from './QueryGene';
import QueryVariant from './QueryVariant';
import QuerySex from './QuerySex';


function BeaconQueryMenu() {
    return (
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={4}>Sex</Grid>
            <Grid item xs={8}>
                <QuerySex />
            </Grid>
            <Grid item xs={4}>Phenotypes</Grid>
            <Grid item xs={8}>
                <QueryPhenotype />
            </Grid>
            <Grid item xs={4}>Diseases</Grid>
            <Grid item xs={8}>
                <QueryDisease />
            </Grid>
            <Grid item xs={4}>Variant</Grid>
            <Grid item xs={8}>
                <QueryVariant />
            </Grid>
            {/*
            <Grid item xs={4}>Gene</Grid>
            <Grid item xs={8}>
                <QueryGene />
            </Grid>
            */}
        </Grid>
    );
}


export default BeaconQueryMenu;
